//NOTICE: 09/04/2018: custom messages in beforeunload dialogs are deprecated since chrome-51
// ->https://developer.chrome.com/blog/chrome-51-deprecations/#remove_custom_messages_in_onbeforeunload_dialogs
// cannot override browser engine default pop-up

import { useEffect } from 'react';

export const useDetectReloadPageLocalstorageClear = (currentStepLocalstorageName?: string) => {
  useEffect(() => {
    const onBeforeUnload = (e: any) => {
      e.preventDefault();
      e.returnValue = '';
      if (currentStepLocalstorageName) {
        localStorage.removeItem(currentStepLocalstorageName);
      }
    };
    window.addEventListener('beforeunload', onBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, [currentStepLocalstorageName]);
};
